import xuexiData from './xuexi.json';

export interface QnA {
  ID: number;
  Question: string;
  Answer: string;
}

export const qnaData: QnA[] = xuexiData;
